var ___EXPOSE_LOADER_IMPORT___ = require("-!./index.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = require("../@servicetitan/startup/dist/webpack/loaders/expose-loader/runtime/get-global-this.js");
var ___EXPOSE_LOADER_STORAGE_KEY___ = Symbol.for('SERVICETITAN_EXPOSE_LOADER_STORAGE');
if (___EXPOSE_LOADER_GLOBAL_THIS___[___EXPOSE_LOADER_STORAGE_KEY___] === undefined) {
  ___EXPOSE_LOADER_GLOBAL_THIS___[___EXPOSE_LOADER_STORAGE_KEY___] = Object.assign(
    Object.create(null),
    {
      clear(scope) {
        delete this[scope];
      },
    }
  );
}
var ___EXPOSE_LOADER_STORAGE___ = ___EXPOSE_LOADER_GLOBAL_THIS___[___EXPOSE_LOADER_STORAGE_KEY___];
if (___EXPOSE_LOADER_GLOBAL_THIS___['SharedDependencies'] === undefined) {
  ___EXPOSE_LOADER_GLOBAL_THIS___['SharedDependencies'] = Object.create(null);
}
___EXPOSE_LOADER_GLOBAL_THIS___.SharedDependencies.ReactDOM = new Proxy(
  Object.assign(Object.create(null), {
    getStorage() {
      return ___EXPOSE_LOADER_STORAGE___;
    },
  }),
  {
    get: function (target, prop, receiver) {
      function getModule(id) {
        if (___EXPOSE_LOADER_STORAGE___[prop] === undefined) {
          ___EXPOSE_LOADER_STORAGE___[prop] = Object.create(null);
        }
        if (___EXPOSE_LOADER_STORAGE___[prop][id] !== undefined) {
          return ___EXPOSE_LOADER_STORAGE___[prop][id].exports;
        }
        var module = (___EXPOSE_LOADER_STORAGE___[prop][id] = {
          id,
          loaded: false,
          exports: Object.create(null),
        });
        __webpack_modules__[id].call(module.exports, module, module.exports, getModule);
        module.loaded = true;
        return module.exports;
      }
      Object.setPrototypeOf(getModule, __webpack_require__);
      if (prop === 'getStorage') {
        return Reflect.get(target, prop, receiver);
      }
      return getModule(require.resolveWeak("-!./index.js"))
    },
  }
);
module.exports = ___EXPOSE_LOADER_IMPORT___;
